import React from "react";
import { Box } from "@mui/material";
import ReactPlayer from "react-player";
import { DialogComponent } from "../../atom";

const CourseWalkthroughModal = ({
  open,
  videoUrl,
  onEnded,
  onClose = () => { },
  isMandatory = false,
  courseName,
}) => {
  if (!open || !videoUrl) return null;

  return (
    <DialogComponent
      open={open}
      maxwidth="md"
      onClose={isMandatory ? () => { } : onClose}
      isShowCloseButton={!isMandatory}
      btntextone={!isMandatory ? "Skip" : undefined}
      onclickone={onClose}
      title={`Walkthrough Video of ${courseName || "Course"}`}
    >
      <Box
        sx={{
          width: "100%",
          backgroundColor: "#000000",
          p: 0,
          m: 0,
          display: "flex",
          flexDirection: "column",
          position: "relative",
        }}
      >
        <Box
          sx={{
            width: "100%",
            aspectRatio: "16/9",
            overflow: "hidden",
            backgroundColor: "#000000",
            p: 0,
            m: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
          }}
        >
          <ReactPlayer
            key={videoUrl}
            width="100%"
            height="100%"
            url={videoUrl}
            playing={true}
            loop={false}
            controls={true}
            muted={false}
            onEnded={onEnded}
            config={{
              file: {
                attributes: {
                  autoPlay: true,
                  controlsList: "nodownload",
                  style: { width: "100%", height: "100%", objectFit: "cover" },
                },
              },
            }}
          />
        </Box>

      </Box>
    </DialogComponent>
  );
};

export default CourseWalkthroughModal;

